module.exports = __webpack_public_path__ + "assets/img/6.554d291b.png";